import React from "react";
import "./Navbar.css";
import {Link, Navigate, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../features/User/UserSlice";
import {adminLogout} from '../../features/Admin/AdminSlice'

export default function Navbar({ colorLeft, colorRight }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {BookWormUser} = useSelector((state) => state);
  const handleLogout = () => { 
    dispatch(adminLogout())
    dispatch(logout())

    alert("User has been Logged Out");
  }
  return (
    <nav className="navbar navbar-expand-lg  bg-body-tertiary Navbar" >
      <div className="container-fluid">
        <Link  style={{ color: colorLeft}} className="navbar-brand" to="">
          {/* <img src="/images/logo.png" className='NavbarImg' alt="" /> */}
          BookWorm.in
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" style={{ gap: "2%" }} id="navbarNavDropdown">
          <ul className="navbar-nav"  >
            <li className="nav-item">
              <Link className="nav-link active" style={{color:colorRight,textDecoration:"none"}} aria-current="page"  to="../">Home</Link>
            </li>            
            <li className="nav-item">
            {
              BookWormUser.token && <Link  className="nav-link" style={{ color: colorRight, textDecoration: "none" }} onClick={handleLogout} to="/auth" >Logout</Link>
            }
            </li>            
            <li className="nav-item">
            {
              BookWormUser.token && <Link className="nav-link" style={{ color: colorRight, textDecoration: "none" }} to="/dashboard" >Dashboard</Link>
            }
            </li>            
            <li className="nav-item">
            {
             !BookWormUser.token && <Link className="nav-link" style={{ color: colorRight, textDecoration: "none" }} to="/auth" >SignUp </Link>
            }
            </li>                       
            <li className="nav-item">
            {
             BookWormUser.token && <Link className="nav-link" style={{ color: colorRight, textDecoration: "none" ,display:"flex",gap:"5px",alignItems:"center"}} to="/cart" ><i className="fa-solid fa-cart-plus"></i> MyCart </Link>
            }
            </li>            
            <li className="nav-item">
            {
             BookWormUser.token && <Link className="nav-link" style={{ color: colorRight, textDecoration: "none" ,display:"flex",gap:"5px",alignItems:"center"}} to="/orders" ><i className="fa-solid fa-basket-shopping"></i> MyOrders</Link>
            }
            </li>            
          </ul>
          <button type="button" style={{color:colorRight}} className="btn" onClick={()=>{navigate("/postAd")}}><i className="fa-solid fa-plus"></i> Sell Books</button>
          
        </div>
      </div>
    </nav>
  );
}
